import { connect } from 'react-redux';

import decorate from '../../utils/decorate';

import { request as queryCompetitions } from '../../modules/competitions/actions/query';
import { request as getSports } from '../../modules/sports/actions/get';
import * as bets from '../../modules/bet-ticker/actions/subscription';
import { openWindow } from '../../modules/bet-ticker/actions/subscription';

import BetTicker from './BetTicker.jsx';

const STATE_KEY = 'bet-ticker';

function mapStateToProps(state) {
    return {
        sports: state.sports.get('items').toList(),
        competitions: state.competitions.get('items').toList(),
        betTicker: state.betTicker.get('items')
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        onGetSportsRequest: () => dispatch(getSports()),
        onQueryCompetitionsRequest: (query) => dispatch(queryCompetitions(STATE_KEY, query)),
        onGetBets: () => dispatch(bets.subscribe()),
        onGetRejectedBets: () => dispatch(bets.subscribeRejected()),
        onGetSettledBets: () => dispatch(bets.subscribeSettled()),
        routeToANewTab: (args) => dispatch(openWindow(args))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    BetTicker
);
